
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-brokerage-license",
      function () {
        return require("private-next-pages/real-estate-brokerage-license.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-brokerage-license"])
      });
    }
  